// src/components/utils/getCurrentUser.ts

import { IPublicClientApplication } from "@azure/msal-browser";

export async function getCurrentUser(client?: IPublicClientApplication): Promise<{ name?: string; email?: string }> {
    if (typeof window === "undefined") return {};

    // MSAL account
    const account = client?.getActiveAccount();
    if (account) {
        return {
            name: account?.name,
            email: account?.username
        };
    }

    // Local dev fallback
    const hostname = window.location.hostname;
    if (hostname === "localhost" || hostname === "127.0.0.1") {
        return {
            name: "Dev User",
            email: "dev@localhost"
        };
    }

    return {};
}
